export default __webpack_public_path__ + "static/logo-min-f8072e23add2bed0cd726c018a0d420e.png";